import React from 'react';
import classnames from 'classnames/bind';
import { get } from 'lodash';

import styles from './postOptionsStyles';

import Button, { BUTTON_TYPES } from 'buyside/components/presentation/Button/button';
import { filterOps } from 'buyside/components/presentation/Feed/FeedFilterPanel/feedFilterPanel';
import LoadingSpinner, {
  SIZES
} from 'buyside/components/presentation/LoadingSpinner/loadingSpinner';

import XMarkIcon from 'SVGs/x_mark';

import { useDestroyPostMutation } from 'interfaces/graphql-typings';

const cx = classnames.bind(styles);

const Feed = require('buyside/graphql/queries/Feed');

const PostOptions = ({ feedItemId, headerType }) => {
  const feedType = window.location.pathname.includes('entities') ? 'Entity' : '';

  const [deletePost, { loading, error }] = useDestroyPostMutation({
    update(cache, { data }) {
      const feedId = get(data, ['destroyPost', 'feedItem', 'feedId']);

      cache.updateQuery(
        {
          query: Feed,
          variables: { feedId, feedType, feedFilter: feedType === 'Entity' ? filterOps[0] : '' }
        },
        data => {
          if (!get(data, ['feedItems', 'edges']) || !get(data, ['feedItems', 'pageInfo']))
            return null;
          return {
            feedItems: {
              edges: data.feedItems.edges.filter(edge => edge.node.id !== feedItemId),
              pageInfo: data.feedItems.pageInfo
            }
          };
        }
      );

      const cachedFeedQueryRes = cache.readQuery({ query: Feed, variables: { feedId, feedType } });
      if (cachedFeedQueryRes && feedId) {
        cache.writeQuery({
          query: Feed,
          data: {
            feedItems: {
              edges: cachedFeedQueryRes.feedItems.edges.filter(edge => edge.node.id !== feedItemId),
              pageInfo: cachedFeedQueryRes.feedItems.pageInfo
            }
          }
        });
      }
    }
  });

  const handleDelete = () => {
    if (confirm('Are you sure you want to delete this post?')) {
      deletePost({ variables: { feedItemId } });
    }
  };

  return (
    <div
      className={cx(styles.postOptionsButtonWrap, {
        isComment: headerType === 'PUBLISH_COMMENT'
      })}
    >
      {loading ? (
        <LoadingSpinner size={SIZES.NANO} />
      ) : (
        <Button
          text="Delete Post"
          onClick={handleDelete}
          value={feedItemId}
          type={BUTTON_TYPES.LINK}
          icon={XMarkIcon}
          className={styles.postOptionsButton}
          iconStyle={styles.iconAdjust}
        />
      )}
      <span>{error && get(error, ['graphQLErrors', '0', 'message'])}</span>
    </div>
  );
};

export default PostOptions;
